import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetInvoiceScansApi } from './use-get-invoice-scans-api';

const endpoint = 'ums/v1/cms/invoice-scanning/scans';

type TData = void;
type TError = AxiosError;
type TVariables = { scanId: number };
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useDeleteInvoiceScanApi(options?: Options): ReturnType {
  const { refetch: refetchScans } = useGetInvoiceScansApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ scanId }: TVariables) => {
    try {
      await http.delete(`${endpoint}/${scanId}`);
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [endpoint],
    onSuccess: () => {
      refetchScans();
      toast({
        description: 'Invoice scan has been deleted successfully',
        status: 'success',
      });
    },
  });
}
